import { HttpErrorResponse } from '@angular/common/http';

/** Mensaje legible a partir de errores HTTP del API de ingesta. */
export function messageFromIngestHttpError(err: unknown, fallback: string): string {
  if (err instanceof HttpErrorResponse) {
    const body = err.error;
    if (body && typeof body === 'object' && !Array.isArray(body)) {
      const o = body as Record<string, unknown>;
      if (typeof o['detail'] === 'string' && o['detail'].trim()) {
        return o['detail'].trim();
      }
      if (typeof o['message'] === 'string' && o['message'].trim()) {
        return o['message'].trim();
      }
    }
    if (typeof body === 'string' && body.trim()) {
      const text = body.trim();
      if (text.startsWith('{')) {
        try {
          const json = JSON.parse(text) as { detail?: string; message?: string };
          if (json.detail?.trim()) return json.detail.trim();
          if (json.message?.trim()) return json.message.trim();
        } catch {
          /* cuerpo no JSON */
        }
      }
      if (text.length < 500 && !text.toLowerCase().includes('<!doctype')) {
        return text;
      }
    }
    if (err.status === 500) {
      return 'El servidor devolvió un error interno (500). Revise la configuración del tenant y los logs del backend.';
    }
    if (err.status === 0) {
      return 'No se pudo contactar al servidor. Revisa la red, el proxy y CORS.';
    }
    if (err.status === 401 || err.status === 403) {
      return 'No autorizado. Revisa la sesión o el token.';
    }
    if (err.status) {
      const statusText = err.statusText ? ` (${err.statusText})` : '';
      return `Error ${err.status}${statusText}.`;
    }
  }
  if (err instanceof Error && err.message.trim()) {
    return err.message.trim();
  }
  return fallback;
}
